<template>
  <div class="privacy-root">
    <!-- NAV minimal -->
    <nav class="priv-nav">
      <div class="priv-nav-inner">
        <router-link to="/" class="priv-back">← Volver al inicio</router-link>
        <router-link to="/sistema" class="priv-cta">Ir al Sistema →</router-link>
      </div>
    </nav>

    <div class="priv-container">
      <h1 class="priv-title">Política de Privacidad</h1>
      <p class="priv-meta">Última actualización: Marzo 2026</p>

      <section class="priv-section">
        <h2>1. Información General</h2>
        <p>
          <strong>CucuruchoOnline</strong> ("la Plataforma") es un sistema de gestión digital
          para hermandades de Guatemala. Esta política describe cómo recopilamos, usamos
          y protegemos la información personal de nuestros usuarios.
        </p>
        <p>
          Al utilizar nuestra plataforma o al recibir mensajes a través de WhatsApp de
          nuestra parte, aceptás los términos de esta política.
        </p>
      </section>

      <section class="priv-section">
        <h2>2. Datos que Recopilamos</h2>
        <p>Recopilamos únicamente los datos necesarios para el funcionamiento del sistema:</p>
        <ul>
          <li><strong>Nombre completo</strong> del cargador o usuario registrado.</li>
          <li><strong>Número de teléfono (WhatsApp)</strong>, utilizado para el envío de notificaciones y comunicaciones relacionadas con la procesión.</li>
          <li><strong>Correo electrónico</strong> del administrador de la hermandad.</li>
          <li><strong>Rol dentro de la hermandad</strong> (administrador, cargador, etc.).</li>
          <li><strong>Datos de ubicación del dispositivo rastreador</strong> (coordenadas GPS), utilizados exclusivamente para mostrar la ubicación de la procesión en tiempo real.</li>
        </ul>
      </section>

      <section class="priv-section">
        <h2>3. Uso de los Datos</h2>
        <p>Los datos recopilados se utilizan <strong>exclusivamente</strong> para:</p>
        <ul>
          <li>Gestionar inscripciones y turnos de cargadores dentro de la hermandad.</li>
          <li>Enviar <strong>notificaciones operativas</strong> vía WhatsApp (confirmaciones de inscripción, avisos de turno, información del recorrido).</li>
          <li>Mostrar la ubicación en tiempo real de la procesión en el mapa de seguimiento público.</li>
          <li>Administrar el acceso al sistema por parte de los responsables de la hermandad.</li>
        </ul>
        <p class="priv-highlight">
          🚫 <strong>No utilizamos ningún dato personal con fines publicitarios, no los
          vendemos, ni los compartimos con terceros</strong> salvo que sea estrictamente
          necesario para la operación del servicio (por ejemplo, proveedores de
          infraestructura tecnológica como AWS).
        </p>
      </section>

      <section class="priv-section">
        <h2>4. Uso de WhatsApp Business API</h2>
        <p>
          CucuruchoOnline utiliza la <strong>WhatsApp Business API</strong> para enviar
          notificaciones a los usuarios que así lo hayan acordado con su hermandad.
        </p>
        <ul>
          <li>Los mensajes enviados a través de WhatsApp son de carácter <strong>informativo y operativo</strong>.</li>
          <li>No se enviarán mensajes publicitarios ni se utilizará WhatsApp para fines distintos a la gestión de la hermandad.</li>
          <li>Los datos de número de teléfono utilizados para WhatsApp <strong>no se comparten con ningún tercero</strong> más allá de la infraestructura de Meta Platforms para el envío del mensaje.</li>
          <li>Los datos de mensajería no se usan para perfilar usuarios ni para publicidad.</li>
        </ul>
      </section>

      <section class="priv-section">
        <h2>5. Retención de Datos</h2>
        <p>
          Los datos personales se conservan mientras el usuario o la hermandad mantenga
          una cuenta activa en la plataforma. Una vez que se solicite la eliminación de
          la cuenta, los datos serán eliminados dentro de un plazo máximo de
          <strong>30 días hábiles</strong>.
        </p>
      </section>

      <section class="priv-section">
        <h2>6. Derechos del Usuario</h2>
        <p>Todo usuario tiene derecho a:</p>
        <ul>
          <li><strong>Acceder</strong> a los datos personales que tenemos sobre él.</li>
          <li><strong>Corregir</strong> datos incorrectos o desactualizados.</li>
          <li><strong>Solicitar la eliminación</strong> de sus datos personales.</li>
          <li><strong>Retirar su consentimiento</strong> para el envío de mensajes vía WhatsApp en cualquier momento.</li>
        </ul>
        <p>Para ejercer cualquiera de estos derechos, contactá al administrador del sistema.</p>
      </section>

      <section class="priv-section">
        <h2>7. Contacto</h2>
        <p>
          Para consultas, solicitudes de eliminación de datos o cualquier pregunta
          relacionada con esta política de privacidad, podés comunicarte con el
          responsable del sistema a través del siguiente correo electrónico:
        </p>
        <p class="priv-email">
          📧 <a href="mailto:info@cucuruchonline.com">info@cucuruchonline.com</a>
        </p>
      </section>

      <section class="priv-section">
        <h2>8. Cambios a esta Política</h2>
        <p>
          Nos reservamos el derecho de actualizar esta política de privacidad cuando sea
          necesario. Cualquier cambio significativo será notificado a los usuarios
          registrados. La fecha al inicio de este documento indica la versión vigente.
        </p>
      </section>
    </div>

    <!-- FOOTER minimal -->
    <footer class="priv-footer">
      <span>© 2026 CucuruchoOnline</span>
      <router-link to="/" class="footer-link">Inicio</router-link>
      <router-link to="/sistema" class="footer-link">Ir al Sistema</router-link>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'PrivacidadView'
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

* { box-sizing: border-box; }

.privacy-root {
  font-family: 'Inter', sans-serif;
  background: #f8f9fd;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* NAV */
.priv-nav {
  background: rgba(10,10,18,0.95);
  backdrop-filter: blur(10px);
  position: sticky;
  top: 0;
  z-index: 100;
}
.priv-nav-inner {
  max-width: 900px;
  margin: 0 auto;
  padding: 14px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.priv-back {
  color: rgba(255,255,255,0.65);
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.2s;
}
.priv-back:hover { color: #fff; }
.priv-cta {
  background: linear-gradient(135deg, #7b2ff7, #4a1b9a);
  color: #fff;
  text-decoration: none;
  padding: 8px 18px;
  border-radius: 8px;
  font-size: 0.88rem;
  font-weight: 600;
  transition: all 0.2s;
}
.priv-cta:hover { opacity: 0.88; }

/* CONTENT */
.priv-container {
  max-width: 860px;
  margin: 0 auto;
  padding: 60px 32px 80px;
  flex: 1;
}
.priv-title {
  font-size: 2.2rem;
  font-weight: 800;
  color: #1a1a2e;
  margin-bottom: 6px;
}
.priv-meta {
  color: #999;
  font-size: 0.9rem;
  margin-bottom: 48px;
}
.priv-section {
  background: #fff;
  border-radius: 14px;
  padding: 32px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  border: 1px solid rgba(0,0,0,0.05);
}
.priv-section h2 {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 14px;
  padding-bottom: 10px;
  border-bottom: 2px solid #f0f0f8;
}
.priv-section p {
  color: #4a4a6a;
  font-size: 0.97rem;
  line-height: 1.75;
  margin-bottom: 10px;
}
.priv-section p:last-child { margin-bottom: 0; }
.priv-section ul {
  margin: 10px 0 10px 20px;
  color: #4a4a6a;
  font-size: 0.97rem;
  line-height: 1.75;
}
.priv-section li { margin-bottom: 6px; }
.priv-highlight {
  background: linear-gradient(135deg, rgba(123,47,247,0.06), rgba(74,27,154,0.08));
  border: 1px solid rgba(123,47,247,0.15);
  border-radius: 10px;
  padding: 16px 20px !important;
  color: #3a1a5e !important;
  margin-top: 14px !important;
}
.priv-email {
  font-size: 1.05rem !important;
  margin-top: 12px !important;
}
.priv-email a {
  color: #7b2ff7;
  text-decoration: none;
  font-weight: 600;
}
.priv-email a:hover { text-decoration: underline; }

/* FOOTER */
.priv-footer {
  background: #07070f;
  color: rgba(255,255,255,0.4);
  font-size: 0.85rem;
  padding: 20px 32px;
  display: flex;
  gap: 24px;
  justify-content: center;
  align-items: center;
}
.footer-link {
  color: rgba(255,255,255,0.4);
  text-decoration: none;
  transition: color 0.2s;
}
.footer-link:hover { color: rgba(255,255,255,0.75); }

@media (max-width: 768px) {
  .priv-container { padding: 40px 16px 60px; }
  .priv-title { font-size: 1.7rem; }
  .priv-section { padding: 22px; }
}
</style>
